import React from 'react';
import { SpotInterface } from 'types';
import WidgetBox from '../widgets/WidgetBox';
import CurrentRates from './CurrentRates';

type StandardPricingWidgetProps = {
    spot: SpotInterface;
};

function StandardPricingWidget({ spot }: StandardPricingWidgetProps): JSX.Element {
    return (
        <WidgetBox title="">
            <CurrentRates spot={spot} rates={null} />
        </WidgetBox>
    );
}

export default StandardPricingWidget;
